module.exports = "<div class=\"overlay\" *ngIf=\"showLoading\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 col-sm-12 col-xs-12\">\r\n            <div class=\"container\" style=\"padding-top:120px;\">\r\n                <img id=\"imgLoader\" src=\"./assets/images/AnimationLoading.gif\" height=\"100px\" width=\"100px\" alt=\"Loading\" class=\"mx-auto d-block\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main